import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Course, ExperienceType } from '@shared/models/course.model';
import { LoadState } from '@app/main/analytics/loader-directive/loader.module';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { AnalyticsService, GeneralStats, StatCard } from '@shared/services/analytics.service';
import { DurationConverter } from '../../misc/duration-converter.pipe';
import { Hub, ProgramTabs } from '@shared/models';
import { Params, Router } from '@angular/router';
@Component({
  selector: 'hub-experience-card',
  templateUrl: './hub-experience-card.component.html',
  styleUrls: ['./hub-experience-card.component.scss']
})
export class HubExperienceCardComponent implements OnInit {
  @Input() course_id: string;
  @Input() hub: Hub;
  @Input() sessionCount: number;
  @Input() date_from: Date;
  @Input() date_to: Date;
  public loadStatus: string;
  public course: Course;
  public loadError: boolean = false;
  statsCards: StatCard[];

  constructor(
    private _courseAPIService: CoursesAPIService,
    private _analyticsService: AnalyticsService,
    private _router: Router
  ) {

  }
  async ngOnInit(): Promise<void> {
    this.loadStatus = LoadState.loading;
    try {
      this.course = await this._courseAPIService.getCourseById(this.course_id).toPromise();
      await this.updateStats();
    }
    catch (e) {
      this.loadError = true;
    }
    this.loadStatus = LoadState.completed;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (!this.course) return;
    if ((changes.date_from && changes.date_from.currentValue !== changes.date_from.previousValue) || (changes.date_to && changes.date_to.currentValue !== changes.date_to.previousValue)) {
      this.updateStats();
    }
  }
  updateStats(): void {
    this.loadStatus = LoadState.loading;
    this._analyticsService.getCourseStats(this.course.id, { dateFrom: this.date_from, dateTo: this.date_to }).subscribe(stats => {
      this.loadStatus = LoadState.completed;
      this.statsCards = this.getStatCards(stats)//getGeneralStatCards(stats, false, false);
    }, () => {
      this.loadStatus = LoadState.error;
    });
  }
  getStatCards(stats: GeneralStats): StatCard[] {
    const visitorStatCard = {
      icon: 'fa-users',
      label: `<span class="figure">${stats?.usersCount || 0} </span>&nbsp;<span class="label">${(!isNaN(stats?.usersCount) && stats?.usersCount) > 1 ? ' Visitors' : ' Visitor'}</span>`,
      sublabel: 'including ' + (stats?.anonymousUsersCount || 0) + ' guests'
    }
    const sessionStatCard = {
      icon: 'fa-eye',
      label: `<span class="figure"> ${stats?.sessionCount}</span>&nbsp;<span class="label"> Sessions </span>`,
      sublabel: `${Math.floor((stats?.avgSessionPerVisitor || 0))} sessions/visitor`
    }

    const durationStatCard = {
      icon: 'fa-clock',
      label: `<span class="figure"> ${DurationConverter.prototype.transform(stats.avgDuration, "hh:mm")}</span>&nbsp;<span class="label">/session</span>`,
      sublabel: `${DurationConverter.prototype.transform(stats.totalDuration, "hh:mm")} spent in total`
    }

    const statCards = [visitorStatCard, sessionStatCard, durationStatCard]
    if (stats && stats.totalAIVoiceMinutes > 0) {
      const aiStatCard = {
        icon: 'fa-message',
        label: `<span class="figure"> ${Math.ceil((stats?.totalAIVoiceMinutes || 0))}</span>&nbsp;<span class="label"> AI Voice Min </span>`,
        sublabel: `${Math.ceil((stats?.avgAIVoiceMinutes || 0))} AI Voice Min/session`
      }
      statCards.push(aiStatCard)
    }
    return statCards;
  }

  goToAnalytics(): void {
    if (this.course.experience_type === ExperienceType.ai) {
      this._router.navigate([`${this.hub.urlTitle}/${this.course.learnspace_id}`], {
        queryParams: { activeTab: ProgramTabs.Reporting, simulationId: this.course.id }
      });
    } else {
      this._router.navigate([`${this._router.url}/${this.course.learnspace_id}/courses/${this.course.id}`], {
        queryParams: {
          'activeTab': null,
        },
        queryParamsHandling: 'merge'
      });
    }
  }

}
